// 越南
import twLocale from 'element-ui/lib/locale/lang/vi'

export default {
  ...twLocale
}
